import { oAuthCodeResultSchema, oAuthIdTokenResultSchema } from '../../schemas/oauth';

export function parseRedirectUrl(search: string) {
    const searchParams = new URLSearchParams(search.slice(1));
    const result = oAuthCodeResultSchema.parse(Object.fromEntries(searchParams.entries()));

    return result;
}

export function parseDemoRedirectUrl(hash: string) {
    const searchParams = new URLSearchParams(hash.slice(1));
    const result = oAuthIdTokenResultSchema.parse(Object.fromEntries(searchParams.entries()));

    return result;
}
